module.exports = __webpack_public_path__ + "18da2ef6.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/paperclip.png
// module id = 1165
// module chunks = 0 1 2